import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { ModalTools } from "@Utilities/ModalTools";
import { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";
import { PersonalInformation } from "./PersonalInformation";
import { Positions } from "./Positions";
import { BackgroundCheck } from "./BackgroundCheck";

import "./SeasonalApplication.scss";

class SeasonalApplication extends BasePage
{
	public Form: HTMLFormElement | null = document.getElementById("frmSeasonalApplication") as HTMLFormElement | null;
	public Validation: UnobtrusiveValidation;
	private AppQuestions: HTMLElement | null = document.getElementById("appQuestions");
	private Step: string | null = this.AppQuestions?.getAttribute("data-step");

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();

		if (this.Step !== "confirmation")
		{
			this.Validation = new UnobtrusiveValidation();

			this.Validation.Ajax.AjaxOnFailure = (xhr: XMLHttpRequest) =>
			{
				ModalTools.DisplayAlert("An error occurred while processing your request. Please try again.");
			};

			this.Validation.Ajax.AjaxOnSuccess = (xhr: XMLHttpRequest) =>
			{
				const elmnt = document.getElementById("suggestion") as HTMLElement;
				elmnt?.scrollIntoView();
			};

			this.ConfigureFields();
		}
	}

	public ConfigureFields = (): void =>
	{
		if (this.Step === "personalInformation")
		{
			new PersonalInformation(this.Validation, this.Form as HTMLFormElement);
		}
		else if (this.Step === "positions")
		{
			new Positions(this.Validation, this.Form as HTMLFormElement);
		}
		else if (this.Step === "backgroundCheck")
		{
			new BackgroundCheck(this.Validation, this.Form as HTMLFormElement);
		}
	};
}

const seasonalApplication = new SeasonalApplication();